class CountryProvinceComponent extends HTMLElement { constructor() { super(), this.countrySelect = this.querySelector('[name="address[country]"]'), this.provinceSelect = this.querySelector('[name="address[province]"]'), this.countrySelect && this.provinceSelect && (this.provinceWrapper = this.provinceSelect.parentElement, this.handleCountryChange = this.handleCountryChange.bind(this), this.countrySelect.addEventListener("change", this.handleCountryChange)) } connectedCallback() { this.init() } init() { const e = this.dataset.country; if (e) { const t = Array.from(this.countrySelect.options).findIndex(t => t.textContent === e || t.value === e); this.countrySelect.selectedIndex = Math.max(0, t) } this.handleCountryChange() } handleCountryChange() { const e = this.countrySelect.options[this.countrySelect.selectedIndex]; if (e && e.dataset.provinces) try { const t = JSON.parse(e.dataset.provinces); if (!Array.isArray(t) || 0 === t.length) return void this.clearAndHideProvinces(); this.populateProvinces(t) } catch (e) { console.error("[CountryProvinceComponent] Failed to parse provinces:", e), this.clearAndHideProvinces() } else this.clearAndHideProvinces() } clearAndHideProvinces() { this.provinceSelect.innerHTML = "", this.provinceWrapper.style.display = "none" } populateProvinces(e) { this.provinceSelect.innerHTML = "", e.forEach(([e, t]) => { const n = t === this.dataset.province || e === this.dataset.province; this.provinceSelect.options.add(new Option(t, e, n, n)) }), this.provinceWrapper.style.display = "" } } customElements.get("country-province-component") || customElements.define("country-province-component", CountryProvinceComponent); const ShippingCalculatorAPI = { getEndpoint: () => `${window.routes?.cart_url || window.theme?.routes?.cart_url || "/cart"}/shipping_rates.json`.replace(/\/\//g, "/"), async fetchRates(e, t, n) { const i = JSON.stringify({ shipping_address: { zip: e, country: t, province: n } }), o = await fetch(this.getEndpoint(), { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: i }); if (!o.ok) { throw await o.json().catch(() => ({ error: "Network response was not ok" })) } return o.json() } }, ShippingCalculatorUI = { renderRates(e, t) { const n = window.theme?.strings || window.shippingCalculatorStrings || { shippingEstimatorNoResults: "No shipping rates found.", shippingEstimatorOneResult: "We found one shipping rate:", shippingEstimatorMultipleResults: "We found multiple shipping rates:" }, i = t.length; let o = n.shippingEstimatorNoResults || "No shipping rates found.", r = "error"; 1 === i ? (o = n.shippingEstimatorOneResult || "We found one shipping rate:", r = "success") : i > 1 && (o = n.shippingEstimatorMultipleResults || "We found multiple shipping rates:", r = "success"); const s = i > 0 ? `<ul class="list-disc grid gap-xl p-0 m-0" role="list" style="list-style: none; padding-left: 0;">\n        ${t.map(e => { const t = void 0 !== window.theme && "function" == typeof window.formatMoney ? window.formatMoney(100 * e.price, window.theme.settings?.money_with_currency_format) : `${e.currency} ${e.price}`; return `<li style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; border-bottom: 1px solid #eee; padding-bottom: 8px;">\n                      <span><strong>${e.presentment_name}:</strong> ${t}</span>\n                      <button type="button" class="apply-shipping-rate button button--outline" style="padding: 4px 12px; font-size: 0.85em; min-height: unset; line-height: 1;" data-price="${e.price}">Apply</button>\n                    </li>` }).join("")}\n       </ul>` : ""; e.innerHTML = `\n      <div class="alertBox alertBox--${r} grid gap-xl">\n        <p>${o}</p>\n        ${s}\n      </div>\n    ` }, renderError(e, t) { const n = window.theme?.strings || window.shippingCalculatorStrings || { shippingEstimatorError: "There was an error calculating shipping." }; let i = ""; i = t && "object" == typeof t ? Object.keys(t).map(e => `<li>${e}: ${Array.isArray(t[e]) ? t[e].join(", ") : t[e]}</li>`).join("") : `<li>${t}</li>`, e.innerHTML = `\n      <div class="alertBox alertBox--error grid gap-xl">\n        <p>${n.shippingEstimatorError || "Error"}</p>\n        <ul class="list-disc grid gap-xl p-0 m-0" role="list">${i}</ul>\n      </div>\n    ` } }; async function processShippingCalculation(e) { const t = e.querySelector('[type="submit"]'), n = e.querySelector(".results"), i = e.querySelector('[name="address[zip]"]'), o = e.querySelector('[name="address[country]"]'), r = e.querySelector('[name="address[province]"]'); if (t && n && i && o && r) { t.setAttribute("aria-busy", "true"), n.hidden = !0; try { const e = await ShippingCalculatorAPI.fetchRates(i.value, o.value, r.value); e.shipping_rates ? ShippingCalculatorUI.renderRates(n, e.shipping_rates) : ShippingCalculatorUI.renderError(n, e) } catch (e) { ShippingCalculatorUI.renderError(n, e) } finally { n.hidden = !1, t.removeAttribute("aria-busy") } } } document.addEventListener("click", e => { if (e.target.classList.contains("apply-shipping-rate")) { const t = e.target.dataset.price, n = 100 * parseFloat(t), i = document.querySelector(".cart-drawer-total-price"); if (i && i.dataset.cartTotal) { const t = parseInt(i.dataset.cartTotal, 10) + n, o = void 0 !== window.theme && "function" == typeof window.formatMoney ? window.formatMoney(t, window.theme.settings?.money_with_currency_format) : "" + t / 100; i.innerHTML = o; document.querySelectorAll(".apply-shipping-rate").forEach(e => { e.innerText = "Apply", e.classList.remove("button--solid"), e.classList.add("button--outline") }), e.target.innerText = "Applied", e.target.classList.remove("button--outline"), e.target.classList.add("button--solid"); const r = document.querySelector("[data-shipping-fee-value]"); if (r) if (0 === n) r.innerHTML = "Free"; else { const e = void 0 !== window.theme && "function" == typeof window.formatMoney ? window.formatMoney(n, window.theme.settings?.money_with_currency_format) : "" + n / 100; r.innerHTML = e } const s = e.target.closest("details"); s && s.removeAttribute("open") } } }); class ShippingCalculatorComponent extends HTMLFormElement { constructor() { super(), this.handleFormSubmit = this.handleFormSubmit.bind(this), this.addEventListener("submit", this.handleFormSubmit) } handleFormSubmit(e) { e.preventDefault(), processShippingCalculation(this) } } try { customElements.get("shipping-calculator-component") || customElements.define("shipping-calculator-component", ShippingCalculatorComponent, { extends: "form" }) } catch (e) { console.warn("[ShippingCalculator] Customized built-in elements not fully supported. Falling back to global listener.") } document.addEventListener("submit", e => { const t = e.target; if (t instanceof HTMLFormElement && "shipping-calculator-component" === t.getAttribute("is")) { if (t instanceof ShippingCalculatorComponent) return; e.preventDefault(), processShippingCalculation(t) } }); class FreeShippingComponent extends HTMLElement {
  constructor() {
    super();
    this.update = () => {
      if (window._freeShippingTimeout) {
        clearTimeout(window._freeShippingTimeout);
      }
      window._freeShippingTimeout = setTimeout(() => {
        if (this.isConnected) {
          this._update();
        }

        console.log("update freeshipping")
      }, 200);
    };
  }
  
  connectedCallback() {
    this.update();
    document.addEventListener("currency:change", this.update);
    document.addEventListener('cart:refresh', this.update);
    document.addEventListener('line-item:change:end', this.update);
  }
  
  disconnectedCallback() {
    document.removeEventListener("currency:change", this.update);
    document.removeEventListener('cart:refresh', this.update);
    document.removeEventListener('line-item:change:end', this.update);
  }
  
  findCountryConfig(config, countryCode) {
    if (!config || !countryCode) return null;
    let code = countryCode.toUpperCase();
    let keys = Object.keys(config);
    for (let i = 0; i < keys.length; i++) {
      if (keys[i] === 'default') continue;
      let codes = keys[i].split(',').map(c => c.trim().toUpperCase());
      if (codes.indexOf(code) !== -1) return config[keys[i]];
    }
    return config['default'] || null;
  }
  
  formatMoney(cents) {
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents, window.theme?.settings?.money_with_currency_format);
    }
    let format = window.Shopify?.currency?.format || '${{amount}}';
    if (window.theme?.settings?.money_with_currency_format) {
      format = window.theme.settings.money_with_currency_format;
    }
    let amount = (cents / 100).toFixed(2);
    let amountNoDecimals = (cents / 100).toFixed(0);
    let fmt = format;
    fmt = fmt.replace(/\{\{amount_no_decimals_with_comma_separator\}\}/g, amountNoDecimals);
    fmt = fmt.replace(/\{\{amount_with_comma_separator\}\}/g, amount.replace('.', ','));
    fmt = fmt.replace(/\{\{amount_no_decimals\}\}/g, amountNoDecimals);
    fmt = fmt.replace(/\{\{amount\}\}/g, amount);
    return fmt;
  }

  _update() {
    let usePerCountry = this.dataset.usePerCountry === 'true';
    let currencyRate = parseFloat(this.dataset.currencyRate) || 1;
    
    if (window.Shopify?.currency?.rate !== undefined) {
      let jsRate = parseFloat(window.Shopify.currency.rate);
      if (!isNaN(jsRate) && jsRate > 0) currencyRate = jsRate;
    }

    let currentCountry = (this.dataset.currentCountry || '').toUpperCase();
    let cartTotal = parseInt(this.dataset.cartTotal) || 0;
    let minimum = parseInt(this.dataset.minimum) || 0;
    let shipFeeCents = 0;
    let hasShipFee = false;

    if (usePerCountry) {
      let rawConfig = this.dataset.perCountryConfig;
      if (rawConfig) {
        try {
          let config = JSON.parse(rawConfig);
          let countryConf = this.findCountryConfig(config, currentCountry);
          if (countryConf) {
            minimum = Math.round(countryConf.minimum * currencyRate * 100);
            shipFeeCents = Math.round(countryConf.ship_fee_default * currencyRate * 100);
            hasShipFee = true;
            if (this.dataset.minimum !== String(minimum)) {
              this.dataset.minimum = minimum;
            }
          }
        } catch (e) {
          console.warn('[PerCountryShipping] Invalid JSON config:', e);
        }
      }
    } else {
       let n = window.Shopify?.currency?.rate || 1;
       minimum = Math.round((parseInt(this.dataset.minimum || "0", 10)) * n);
    }

    let isFree = minimum > 0 && cartTotal >= minimum;
    let pct = minimum > 0 ? Math.min(cartTotal / minimum, 1) : 1;
    this.style.setProperty('--percentage', pct);

    let textEl = this.querySelector('.free-shipping-custom--text');
    if (textEl) {
      if (usePerCountry) {
        if (isFree) {
          textEl.innerHTML = '<span>Free shipping applied!</span>';
        } else {
          let remaining = minimum - cartTotal;
          let remainingFormatted;
          try {
            remainingFormatted = this.formatMoney(remaining);
          } catch (e) {
            remainingFormatted = '<span class="money">' + (remaining / 100).toFixed(0) + '</span>';
          }
          let moneyEl = textEl.querySelector('.money, .trans-money');
          if (moneyEl) {
            moneyEl.innerHTML = remainingFormatted;
          } else {
            textEl.innerHTML = 'Faltan ' + remainingFormatted + ' para <span>Envío Gratis</span>';
          }
        }
      } else {
         let s = this.querySelector(".free-shipping-custom--text span");
         if (isFree) {
             textEl.innerHTML = window.theme?.strings?.freeShippingApplied || "Free shipping applied!";
         } else {
             let remaining = minimum - cartTotal;
             let n = "";
             try {
                 let e = window.Shopify?.currency?.active || "USD";
                 n = new Intl.NumberFormat(void 0, { style: "currency", currency: e, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(remaining / 100);
             } catch (e) {
                 n = this.formatMoney(remaining);
             }
             if (s) s.innerHTML = n;
             else {
                 let e = window.theme?.strings?.spendMoreForFreeShipping || `Spend <span class="money">${n}</span> more for FREE shipping.`;
                 textEl.innerHTML = e.includes("<span>") ? e.replace(/<span[^>]*>.*<\/span>/, `<span>${n}</span>`) : `Spend <span class="money">${n}</span> more for FREE shipping.`;
             }
         }
      }
    }

    let feeDisplayEl = document.querySelector('[data-shipping-calculate-value]');
    if (feeDisplayEl) {
      if (!usePerCountry || !hasShipFee) {
        feeDisplayEl.style.cssText += ';display:none!important';
      } else {
        feeDisplayEl.style.removeProperty('display');
        feeDisplayEl.style.display = 'inline';
        feeDisplayEl.innerHTML = isFree ? '<span>FREE</span>' : this.formatMoney(shipFeeCents);
      }
    }

    let totalWrap = document.querySelector('.cart-drawer-total[data-use-per-country]');
    let totalPriceEl = document.querySelector('.cart-drawer-total-price');
    if (totalPriceEl && hasShipFee) {
      let effectiveShip = isFree ? 0 : shipFeeCents;
      let grandTotal = cartTotal + effectiveShip;
      totalPriceEl.innerHTML = this.formatMoney(grandTotal);
      if (totalWrap) totalWrap.dataset.shipFeeCents = effectiveShip;
    }

    let checkoutBtn = document.querySelector('.button.full.checkout span:last-child');
    if (checkoutBtn && hasShipFee) {
      let effectiveShip2 = isFree ? 0 : shipFeeCents;
      let grandTotal2 = cartTotal + effectiveShip2;
      let priceText = this.formatMoney(grandTotal2);
      let bEl = checkoutBtn.querySelector('b');
      if (bEl) {
        Array.from(checkoutBtn.childNodes).forEach(n => {
          if (n !== bEl && n.nodeType === Node.TEXT_NODE && n.previousSibling === bEl) {
            n.textContent = ' ' + priceText;
          }
        });
        checkoutBtn.innerHTML = checkoutBtn.innerHTML.replace(/<b>.*<\/b>[\s\S]*/i, '<b>•</b>\n' + priceText + '\n');
      }
    }
  }
}
customElements.get("free-shipping-component") || customElements.define("free-shipping-component", FreeShippingComponent);